import isbot from 'isbot';

import { isGoogleBot } from '../botCheck';

export const checkIfRequestedByBot = (userAgent: string) => {
  return isbot(userAgent) || isGoogleBot();
};
